import { useContext, useEffect } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import { useGetSpecificDriverQuery } from "../../../Redux/service/Drivers/Drivers";
import Form from "../../Helpers/Form/Form";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../Helpers/Form/FormParts/FormHeader";
import DriverBody from "./DriverBody";
import trans from "../../../utils";

export function DriverForm({ onSuccess, onEdit }) {
  const { form, currentDriverId, isEditing } = useContext(popupcontext);
  const {
    refetch,
    data: driverDetails,
    isError,
  } = useGetSpecificDriverQuery(currentDriverId, {
    skip: !currentDriverId,
  });
  useEffect(() => {
    if (isEditing && currentDriverId) {
      refetch();
    }
  }, [currentDriverId, isEditing, driverDetails, refetch]);

  return (
    <>
      <Form show={form}>
        <Offcanvas.Header>
          <FormHeader
            title={isEditing ? trans("Edit Driver") : trans("Add new driver")}
          />
        </Offcanvas.Header>
        <div className="H-line"></div>
        <Offcanvas.Body>
          <DriverBody
            onSuccess={onSuccess}
            onEdit={onEdit}
            Editvalues={driverDetails?.data}
          />
        </Offcanvas.Body>
      </Form>
    </>
  );
}
